// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"de911da2","160":"a108ce05","196":"470bb56a","246":"f0ea06a9","338":"b868e16b","453":"16c76169","503":"e5fbff1a","868":"652b11e1","893":"0a2d4378"}[chunkId] + ".chunk.js";
};